module.exports = __webpack_public_path__ + "img/for_card.5ae61409.jpeg";